import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, NAV } from "../data/site";

export default function Footer() {
  return (
    <footer className="bg-mm-surface border-t border-mm-green/20" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img src="/assets/logo.png" alt="Mobile Maintenance" className="h-10 w-auto" />
            <p className="mt-5 max-w-sm text-gray-400 leading-relaxed">
              Enhancing the life of your fleet with 24/7/365 mobile maintenance and on-site
              repair nationwide. Over 1,000,000 preventative maintenance services performed.
            </p>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-mm-green mb-4">Explore</h4>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.label}>
                  {n.route ? (
                    <Link to={n.href} className="text-gray-400 hover:text-mm-green transition-colors text-sm">{n.label}</Link>
                  ) : (
                    <a href={`/${n.href}`} className="text-gray-400 hover:text-mm-green transition-colors text-sm">{n.label}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-mm-green mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li><a href={CONTACT.phoneHref} className="flex items-start gap-2 text-gray-400 hover:text-mm-green transition-colors"><Phone size={15} className="mt-0.5 text-mm-green" /> {CONTACT.phone}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="flex items-start gap-2 text-gray-400 hover:text-mm-green transition-colors break-all"><Mail size={15} className="mt-0.5 text-mm-green" /> {CONTACT.email}</a></li>
              <li className="flex items-start gap-2 text-gray-400"><MapPin size={15} className="mt-0.5 text-mm-green" /> {CONTACT.address}</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-mm-green/15 flex flex-col sm:flex-row justify-between gap-4 text-xs text-gray-500 font-mono uppercase tracking-wider">
          <span>© {new Date().getFullYear()} Mobile Maintenance. All rights reserved.</span>
          <span>Odessa, TX • Serving Nationwide • 24/7/365</span>
        </div>
      </div>
    </footer>
  );
}
